var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('XTable',_vm._g({ref:"table",attrs:{"dataApi":_vm.dataApi,"columns":_vm.columns,"paging":false,"params":{batchCode:_vm.getWorkOrder.batchCode}}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }